import { withStore } from 'common/src/vtj/mobx/action-creator'
import RequestStatus from 'todistukset-ui/src/vtj/RequestStatus.enum'

export const getIsOrderPending = () =>
  withStore((store) => {
    return store.order.requestStatus !== RequestStatus.INPUT
  })
